import type { ReactElement } from 'react'
import { Outlet } from 'react-router-dom'

import { CookieConsent } from '@/components/common/CookieConsent'
import { PageViewTracker } from '../common/PageViewTracker'

/** Pathless root route: wraps every page, so global overlays live here. */
export function RootLayout(): ReactElement {
  return (
    <>
      <PageViewTracker />
      <Outlet />
      <CookieConsent />
    </>
  )
}
